import { useState, useEffect } from "react";
import axios from "axios";

export default function ConnectWhatsApp({ tenant_email, connected, onConnect }) {
  const [open, setOpen] = useState(false);
  const [showGuide, setShowGuide] = useState(false);
  const [connectWindow, setConnectWindow] = useState(null);

  const handleConnect = async () => {
    try {
      if (!tenant_email) {
        alert("Tenant email not found. Please re-open the app from your login link.");
        return;
      }
      const resp = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/admin/connect/url`,
        {
          headers: {
            "x-email": tenant_email,
          },
        }
      );
      const url = resp.data.url;
      console.log("Connect URL:", url);

      // Prevent multiple connections
      setOpen(false);
      const win = window.open(url, "connectWhatsApp", "width=900,height=700");
      setConnectWindow(win || null);
    } catch (err) {
      console.error(err);
      alert("Could not start connect flow");
    }
  };

  useEffect(() => {
    if (!connectWindow) return;

    const interval = window.setInterval(() => {
      try {
        if (connectWindow.closed) {
          window.clearInterval(interval);
          setConnectWindow(null);
          if (typeof onConnect === "function") onConnect();
        }
      } catch (e) {
        // If cross-origin access throws, keep polling until it closes.
      }
    }, 1000);

    return () => window.clearInterval(interval);
  }, [connectWindow, onConnect]);

  return (
    <>
      {!connected ? (
        <button className="connect-button" onClick={() => setOpen(true)}>
          Connect WhatsApp
        </button>
      ) : (
        <div className="connected-box">
          {/* <p>
            ✅ Connected to WhatsApp <br />
            <b>Phone:</b> {connectionInfo?.phone_display || "N/A"} <br />
            <b>WABA:</b> {connectionInfo?.whatsapp_waba_id || "N/A"}
          </p> */}
            <button className="secondary-button" onClick={() => setOpen(true)}>
              Reconnect / Change
            </button>
        </div>
      )}

      {/* Modal */}
      {open && (
        <div className="modal-overlay">
          <div className="modal-container">
            <div className="modal-content">
              <div className="modal-header">
                <h2 className="modal-title">Connect your WhatsApp Business</h2>
                <button 
                  className="close-button"
                  onClick={() => setOpen(false)}
                >
                  ×
                </button>
              </div>

              {!showGuide ? (
                <>
                  <p className="modal-description">
                    Do you already have a <b>Meta Business Account</b> with a WhatsApp Business Number?
                  </p>
                  <div className="button-group">
                    <button className="primary-button" onClick={handleConnect}>
                      Yes, I have an account
                    </button>
                    <button 
                      className="secondary-button"
                      onClick={() => setShowGuide(true)}
                    >
                      No, help me create one
                    </button>
                  </div>
                </>
              ) : (
                <>
                  {/* Step-by-step guide */}
                  <div className="guide-container">
                    <div className="step-card">
                      <h3 className="step-title">Step 1: Create a Meta Business Account</h3>
                      <p className="step-description">
                        Go to{" "}
                        <a
                          href="https://business.facebook.com/"
                          target="_blank"
                          rel="noreferrer"
                          className="guide-link"
                        >
                          Meta Business Manager
                        </a>{" "}
                        and create a new Business Account using your Facebook login.
                      </p>
                    </div>
                    
                    <div className="step-card">
                      <h3 className="step-title">Step 2: Add your Business Details</h3>
                      <p className="step-description">
                        Fill in your business name, website, GST (if applicable), and contact
                        details. This helps Meta verify your business identity.
                      </p>
                    </div>
                    
                    <div className="step-card">
                      <h3 className="step-title">Step 3: Create WhatsApp Business Account (WABA)</h3>
                      <p className="step-description">
                        Inside Business Manager, go to{" "}
                        <b>Business Settings → Accounts → WhatsApp Accounts</b> and create a new
                        WhatsApp Business Account.
                      </p>
                    </div>
                    
                    <div className="step-card">
                      <h3 className="step-title">Step 4: Add & Verify a Phone Number</h3>
                      <p className="step-description">
                        Choose a phone number (not already on WhatsApp). Meta will send you an OTP
                        for verification.
                      </p>
                    </div>
                    
                    <div className="step-card">
                      <h3 className="step-title">Step 5: Return & Connect</h3>
                      <p className="step-description">
                        Once your Business Account and Number are ready, click{" "}
                        <b>“Yes, I have an account”</b> to connect it with our platform.
                      </p>
                    </div>
                  </div>

                  <div className="modal-footer">
                    <button 
                      className="secondary-button"
                      onClick={() => setShowGuide(false)}
                    >
                      Back
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
